// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[3].use[1]!../../node_modules/ol/ol.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.map-container {
  display: flex;
  align-items: stretch;
  width: 100%;
  height: 100%;
  position: relative;
}

.map {
  width: 100%;
}

#main-map {
  margin: 0;
  padding: 0;
  width: 100%;
  height: 100%;
  position: relative;
}

#public-map {
  margin: 0;
  padding: 0;
  width: 100%;
  height: 100%;
  position: relative;
  overscroll-behavior-y: contain;
}

/* Map style */

.ol-viewport {
  background-color: #FFF;
}

/* .ol-control button{
  height: 2em !important;
  width: 2em !important;
} */
.ol-custom-control {
  position: absolute;
  z-index: 1;
  left: 2.5em;
  top: 0.5em;
}

.ol-control button {
  color: #fff
}

.ol-control button:hover {
  color: #fff
}

.public-content-wrapper .ol-control button:focus {
  text-decoration: none;
  color: #fff;
  background-color: #0079C9;
  outline: 0;
}

/* .ol-zoom-extent {
  top:5.5em
} */

/* .ol-zoom {
  left: 60px;
} */

.public-routemap-zoom {
  left: 8px;
  top: 60px;
}

/* OL Popup */
.ol-react-popup {
  position: absolute;
  background-color: white;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.2);
  border-radius: 10px;
  border: 1px solid #cccccc;
  bottom: 12px;
  left: -50px;
  min-width: 280px;
}

.ol-react-popup:after,
.ol-react-popup:before {
  top: 100%;
  border: solid transparent;
  content: " ";
  height: 0;
  width: 0;
  position: absolute;
  pointer-events: none;
}

.ol-react-popup:after {
  border-top-color: white;
  border-width: 10px;
  left: 48px;
  margin-left: -10px;
}

.ol-react-popup:before {
  border-top-color: #cccccc;
  border-width: 11px;
  left: 48px;
  margin-left: -11px;
}

/* OL MousePosition Control */

.ol-mouse-position-htrs96 {
  font-size: 0.8em;
  text-shadow: -1px -1px 0 #fff, 1px -1px 0 #fff, -1px 1px 0 #fff, 1px 1px 0 #fff;
  bottom: 40px;
  right: 10px;
  position: absolute;
}

.ol-mouse-position-htrs96:before {
  content: "HTRS96/TM: "
}

.ol-mouse-position-wgs84 {
  font-size: 0.8em;
  text-shadow: -1px -1px 0 #fff, 1px -1px 0 #fff, -1px 1px 0 #fff, 1px 1px 0 #fff;
  bottom: 25px;
  right: 10px;
  position: absolute;
}

.ol-mouse-position-wgs84:before {
  content: "WGS84: "
}

/* OL ZoomSlider Control */
.ol-zoomslider {
  top: 4.5em;
  left: .5em;
  height: 200px;
}

.ol-layerswitcher-image button {
  background-color: white;
  background-image: url("../images/warped-layers.svg") !important;
  /*url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAMAAABEpIrGAAACE1BMVEX///8A//8AgICA//8AVVVAQID///8rVVVJtttgv98nTmJ2xNgkW1ttyNsmWWZmzNZYxM4gWGgeU2JmzNNr0N1Rwc0eU2VXxdEhV2JqytQeVmMhVmNoydUfVGUgVGQfVGQfVmVqy9hqy9dWw9AfVWRpydVry9YhVmMgVGNUw9BrytchVWRexdGw294gVWQgVmUhVWPd4N6HoaZsy9cfVmQgVGRrytZsy9cgVWQgVWMgVWRsy9YfVWNsy9YgVWVty9YgVWVry9UgVWRsy9Zsy9UfVWRsy9YgVWVty9YgVWRty9Vsy9aM09sgVWRTws/AzM0gVWRtzNYgVWRuy9Zsy9cgVWRGcHxty9bb5ORbxdEgVWRty9bn6OZTws9mydRfxtLX3Nva5eRix9NFcXxOd4JPeINQeIMiVmVUws9Vws9Vw9BXw9BYxNBaxNBbxNBcxdJexdElWWgmWmhjyNRlx9IqXGtoipNpytVqytVryNNrytZsjZUuX210k5t1y9R2zNR3y9V4lp57zth9zdaAnKOGoaeK0NiNpquV09mesrag1tuitbmj1tuj19uktrqr2d2svcCu2d2xwMO63N+7x8nA3uDC3uDFz9DK4eHL4eLN4eIyYnDX5OM5Z3Tb397e4uDf4uHf5uXi5ePi5+Xj5+Xk5+Xm5+Xm6OY6aHXQ19fT4+NfhI1Ww89gx9Nhx9Nsy9ZWw9Dpj2abAAAAWnRSTlMAAQICAwQEBgcIDQ0ODhQZGiAiIyYpKywvNTs+QklPUlNUWWJjaGt0dnd+hIWFh4mNjZCSm6CpsbW2t7nDzNDT1dje5efr7PHy9PT29/j4+Pn5+vr8/f39/f6DPtKwAAABTklEQVR4Xr3QVWPbMBSAUTVFZmZmhhSXMjNvkhwqMzMzMzPDeD+xASvObKePPa+ffHVl8PlsnE0+qPpBuQjVJjno6pZpSKXYl7/bZyFaQxhf98hHDKEppwdWIW1frFnrxSOWHFfWesSEWC6R/P4zOFrix3TzDFLlXRTR8c0fEEJ1/itpo7SVO9Jdr1DVxZ0USyjZsEY5vZfiiAC0UoTGOrm9PZLuRl8X+Dq1HQtoFbJZbv61i+Poblh/97TC7n0neCcK0ETNUrz1/xPHf+DNAW9Ac6t8O8WH3Vp98f5lCaYKAOFZMLyHL4Y0fe319idMNgMMp+zWVSybUed/+/h7I4wRAG1W6XDy4XmjR9HnzvDRZXUAYDFOhC1S/Hh+fIXxen+eO+AKqbs+wAo30zDTDvDxKoJN88sjUzDFAvBzEUGFsnADoIvAJzoh2BZ8sner+Ke/vwECuQAAAABJRU5ErkJggg==");*/
  background-position: center;
  background-repeat: no-repeat;
  float: right;
  height: 42px;
  width: 42px;
  display: none;
}

.ol-layerswitcher-image li.ol-layer-hidden {
  opacity: 1;
  border-color: rgba(85, 85, 85, 0.5);
}

.ol-layerswitcher-image li.select,
.ol-layerswitcher-image li.ol-visible {
  border: 3px solid rgb(183, 200, 0);
}



/* Measure Control */
.ol-measure {
  position: absolute;
  top: 10em;
  left: 0.5em;
}

/* Download ShapeFile Control */
/* .ol-download-shape {
  position: absolute;
  top: 14em;
  left: 0.5em;
} */

/* Sidebar Control Button */

.ol-sidebar-control {
  position: relative;
  width: 40px;
  height: 40px;
  border-width: 0px;
  padding: 0px;
}

.ol-sidebar-control>button {
  margin: 0px;
  height: 100%;
  width: 100%;
}

.ol-sidebar-control>button:hover {
  /* background-color: rgba(255,211,58, 0.9); */
}

.ol-bar-sidebar {
  position: relative !important;
}

.ol-thumb-control>button {
  width: 60px;
  height: 60px;
}

.ol-thumb-control.ol-active>button {
  /* background-color: rgb(136,149,0) ; */
}


.sidebar-map .sidebar-left~.ol-sidebar-sticky {
  margin-left: 46px;
  transition: margin-left 500ms;
}

@media (min-width: 600x) and (max-width: 900px) {
  .sidebar-map .sidebar-left~.ol-sidebar-sticky {
    margin-left: 317px;
  }
}

@media (min-width: 900px) and (max-width: 1200px) {
  .sidebar-map .sidebar-left~.ol-sidebar-sticky {
    margin-left: 402px;
  }
}

@media (min-width: 1200px) {
  .sidebar-map .sidebar-left~.ol-sidebar-sticky {
    margin-left: 472px;
  }
}

@media (min-width: 600px) {
  .sidebar-map .sidebar-left.collapsed~.ol-sidebar-sticky {
    margin-left: 52px;
    transition: margin-left 500ms;
  }
}


/* PUBLIC PAGE */
.ol-zoom-public {
  background-color: rgba(0, 0, 0, 0);
  left: auto;

}

@media (min-width: 900px) {
  .ol-zoom-public {
    right: 15px;
    bottom: 125px;
    top: auto;
  }

  .ol-control.ol-rotate-public {
    right: 17px;
    bottom: 237px;
    top: auto;
  }

  .ol-control .ol-zoom-in-public {
    margin-bottom: 15px;
  }
}

@media (max-width: 899px) {
  .ol-zoom-public {
    right: 5px;
    bottom: auto;
    top: 10px;
  }

  .ol-control.ol-rotate-public {
    right: 7px;
    bottom: auto;
    top: 190px;
  }
}

.ol-control.ol-rotate-public {
  border-radius: 50%;
  width: 40px;
  height: 40px;
  background-color: rgba(0, 0, 0, 0);
}


.ol-rotate-reset.ol-rotate-public {
  border-radius: 50%;
  width: 40px;
  height: 40px;
}


.ol-control .ol-zoom-in-public {
  border-radius: 50%;
  width: 40px;
  height: 40px;
  transition: 0.3s;
}

.ol-control .ol-zoom-out-public {
  border-radius: 50%;
  width: 40px;
  height: 40px;
  margin-top: 5px;
  transition: 0.3s;
}

.ol-control .ol-zoom-in-public,
.ol-control .ol-zoom-out-public,
.ol-control .ol-zoom-in-public:hover,
.ol-control .ol-zoom-out-public:hover {
  color: #DDFFD7;
}

button.ol-control-public {
  background-color: #005a96;
  border-radius: 50%;
  height: 40px;
  width: 40px;
}

button.custom-control-public {
  border-radius: 50%;
  height: 40px;
  width: 40px;
}

#overlay-quickactions-overlay {
  position: relative;
  left: 10px;
  margin-top: -17px;
}

#public_desktop_navlink a.active {
  color: #ff6363;
}

.ol-overlaycontainer-stopevent {
  z-index: 1 !important;
}

.pnlm-controls-container {
  right: 24px;
  left: auto;
  bottom: 24px;
  top: auto;
}

.pnlm-fullscreen-toggle-button {
  border-radius: 50%;
  background-color: #BDBDBD;
  background-size: 20px;
  transform: scale(1.4);
  background-position: 3px -36px;
  border-width: 0;
}

.pnlm-fullscreen-toggle-button:hover {
  background-color: #b7b7b7;
}

.pnlm-panorama-info {
  position: absolute;
  top: 4px;
  left: 4px;
  bottom: unset;
  background-color: unset;
  font-family: Roboto, Helvetica, Arial, sans-serif;
  font-size: 0.85rem;
  text-shadow: 1px 1px 5px #000;
}

.pnlm-title-box {
  margin-bottom: 0px
}

#apexchartsprofile-chart .apexcharts-xaxis-texts-g {
  transform: scale(0.92, 0.95) translate(15px, 3px);
}


.public-content-wrapper {
  scrollbar-width: thin;
}

.public-content-wrapper *::-webkit-scrollbar {
  width: 7px;
  height: 7px;
}

.public-content-wrapper *::-webkit-scrollbar-track {
  background: #FAFAFA;
}

/* change color if changing theme */
.public-content-wrapper *::-webkit-scrollbar-thumb {
  background-color: #005A96;
  border: 0px solid #FAFAFA;
}

.apexcharts-tooltip-goals-group .apexcharts-tooltip-z-group {
  display: none
}

.apexcharts-profile-box {
  width: 50px;
  display: flex;
  flex-direction: column;
}

.apexcharts-profile-top {
  margin-top: 1px;
  display: flex;
  flex-direction: column;
  align-items: center;
  font-family: 'Arial';
  font-size: 12px;
}

.apexcharts-profile-bottom {
  margin-bottom: 1px;
  display: flex;
  flex-direction: column;
  align-items: center;
  font-family: 'Arial';
  font-size: 12px;
}

.custom-chart-tooltip {
  margin: 3px;
}

.ol-compass svg {
  filter: invert(100%);
}`, "",{"version":3,"sources":["webpack://./src/styles/map.css"],"names":[],"mappings":"AAEA;EACE,aAAa;EACb,oBAAoB;EACpB,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,SAAS;EACT,UAAU;EACV,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,UAAU;EACV,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA,cAAc;;AAEd;EACE,sBAAsB;AACxB;;AAEA;;;GAGG;AACH;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,UAAU;AACZ;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,yBAAyB;EACzB,UAAU;AACZ;;AAEA;;GAEG;;AAEH;;GAEG;;AAEH;EACE,SAAS;EACT,SAAS;AACX;;AAEA,aAAa;AACb;EACE,kBAAkB;EAClB,uBAAuB;EACvB,wCAAwC;EACxC,mBAAmB;EACnB,yBAAyB;EACzB,YAAY;EACZ,WAAW;EACX,gBAAgB;AAClB;;AAEA;;EAEE,SAAS;EACT,yBAAyB;EACzB,YAAY;EACZ,SAAS;EACT,QAAQ;EACR,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,UAAU;EACV,kBAAkB;AACpB;;AAEA,6BAA6B;;AAE7B;EACE,gBAAgB;EAChB,+EAA+E;EAC/E,YAAY;EACZ,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE;AACF;;AAEA;EACE,gBAAgB;EAChB,+EAA+E;EAC/E,YAAY;EACZ,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE;AACF;;AAEA,0BAA0B;AAC1B;EACE,UAAU;EACV,UAAU;EACV,aAAa;AACf;;AAEA;EACE,uBAAuB;EACvB,+DAA+D;EAC/D,y4CAAy4C;EACz4C,2BAA2B;EAC3B,4BAA4B;EAC5B,YAAY;EACZ,YAAY;EACZ,WAAW;EACX,aAAa;AACf;;AAEA;EACE,UAAU;EACV,mCAAmC;AACrC;;AAEA;;EAEE,kCAAkC;AACpC;;;;AAIA,oBAAoB;AACpB;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;AACb;;AAEA,+BAA+B;AAC/B;;;;GAIG;;AAEH,2BAA2B;;AAE3B;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,uCAAuC;AACzC;;;AAGA;EACE,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,iBAAiB;IACjB,6BAA6B;EAC/B;AACF;;;AAGA,gBAAgB;AAChB;EACE,kCAAkC;EAClC,UAAU;;AAEZ;;AAEA;EACE;IACE,WAAW;IACX,aAAa;IACb,SAAS;EACX;;EAEA;IACE,WAAW;IACX,aAAa;IACb,SAAS;EACX;;EAEA;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,UAAU;IACV,YAAY;IACZ,SAAS;EACX;;EAEA;IACE,UAAU;IACV,YAAY;IACZ,UAAU;EACZ;AACF;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,kCAAkC;AACpC;;;AAGA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;;AAGA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,gBAAgB;AAClB;;AAEA;;;;EAIE,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,UAAU;EACV,YAAY;EACZ,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,qBAAqB;EACrB,qBAAqB;EACrB,8BAA8B;EAC9B,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,aAAa;EACb,uBAAuB;EACvB,iDAAiD;EACjD,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;EACE;AACF;;AAEA;EACE,iDAAiD;AACnD;;;AAGA;EACE,qBAAqB;AACvB;;AAEA;EACE,UAAU;EACV,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA,mCAAmC;AACnC;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE;AACF;;AAEA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,oBAAoB;AACtB","sourcesContent":["@import 'NodeModules/ol/ol.css';\r\n\r\n.map-container {\r\n  display: flex;\r\n  align-items: stretch;\r\n  width: 100%;\r\n  height: 100%;\r\n  position: relative;\r\n}\r\n\r\n.map {\r\n  width: 100%;\r\n}\r\n\r\n#main-map {\r\n  margin: 0;\r\n  padding: 0;\r\n  width: 100%;\r\n  height: 100%;\r\n  position: relative;\r\n}\r\n\r\n#public-map {\r\n  margin: 0;\r\n  padding: 0;\r\n  width: 100%;\r\n  height: 100%;\r\n  position: relative;\r\n  overscroll-behavior-y: contain;\r\n}\r\n\r\n/* Map style */\r\n\r\n.ol-viewport {\r\n  background-color: #FFF;\r\n}\r\n\r\n/* .ol-control button{\r\n  height: 2em !important;\r\n  width: 2em !important;\r\n} */\r\n.ol-custom-control {\r\n  position: absolute;\r\n  z-index: 1;\r\n  left: 2.5em;\r\n  top: 0.5em;\r\n}\r\n\r\n.ol-control button {\r\n  color: #fff\r\n}\r\n\r\n.ol-control button:hover {\r\n  color: #fff\r\n}\r\n\r\n.public-content-wrapper .ol-control button:focus {\r\n  text-decoration: none;\r\n  color: #fff;\r\n  background-color: #0079C9;\r\n  outline: 0;\r\n}\r\n\r\n/* .ol-zoom-extent {\r\n  top:5.5em\r\n} */\r\n\r\n/* .ol-zoom {\r\n  left: 60px;\r\n} */\r\n\r\n.public-routemap-zoom {\r\n  left: 8px;\r\n  top: 60px;\r\n}\r\n\r\n/* OL Popup */\r\n.ol-react-popup {\r\n  position: absolute;\r\n  background-color: white;\r\n  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.2);\r\n  border-radius: 10px;\r\n  border: 1px solid #cccccc;\r\n  bottom: 12px;\r\n  left: -50px;\r\n  min-width: 280px;\r\n}\r\n\r\n.ol-react-popup:after,\r\n.ol-react-popup:before {\r\n  top: 100%;\r\n  border: solid transparent;\r\n  content: \" \";\r\n  height: 0;\r\n  width: 0;\r\n  position: absolute;\r\n  pointer-events: none;\r\n}\r\n\r\n.ol-react-popup:after {\r\n  border-top-color: white;\r\n  border-width: 10px;\r\n  left: 48px;\r\n  margin-left: -10px;\r\n}\r\n\r\n.ol-react-popup:before {\r\n  border-top-color: #cccccc;\r\n  border-width: 11px;\r\n  left: 48px;\r\n  margin-left: -11px;\r\n}\r\n\r\n/* OL MousePosition Control */\r\n\r\n.ol-mouse-position-htrs96 {\r\n  font-size: 0.8em;\r\n  text-shadow: -1px -1px 0 #fff, 1px -1px 0 #fff, -1px 1px 0 #fff, 1px 1px 0 #fff;\r\n  bottom: 40px;\r\n  right: 10px;\r\n  position: absolute;\r\n}\r\n\r\n.ol-mouse-position-htrs96:before {\r\n  content: \"HTRS96/TM: \"\r\n}\r\n\r\n.ol-mouse-position-wgs84 {\r\n  font-size: 0.8em;\r\n  text-shadow: -1px -1px 0 #fff, 1px -1px 0 #fff, -1px 1px 0 #fff, 1px 1px 0 #fff;\r\n  bottom: 25px;\r\n  right: 10px;\r\n  position: absolute;\r\n}\r\n\r\n.ol-mouse-position-wgs84:before {\r\n  content: \"WGS84: \"\r\n}\r\n\r\n/* OL ZoomSlider Control */\r\n.ol-zoomslider {\r\n  top: 4.5em;\r\n  left: .5em;\r\n  height: 200px;\r\n}\r\n\r\n.ol-layerswitcher-image button {\r\n  background-color: white;\r\n  background-image: url(\"../images/warped-layers.svg\") !important;\r\n  /*url(\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAMAAABEpIrGAAACE1BMVEX///8A//8AgICA//8AVVVAQID///8rVVVJtttgv98nTmJ2xNgkW1ttyNsmWWZmzNZYxM4gWGgeU2JmzNNr0N1Rwc0eU2VXxdEhV2JqytQeVmMhVmNoydUfVGUgVGQfVGQfVmVqy9hqy9dWw9AfVWRpydVry9YhVmMgVGNUw9BrytchVWRexdGw294gVWQgVmUhVWPd4N6HoaZsy9cfVmQgVGRrytZsy9cgVWQgVWMgVWRsy9YfVWNsy9YgVWVty9YgVWVry9UgVWRsy9Zsy9UfVWRsy9YgVWVty9YgVWRty9Vsy9aM09sgVWRTws/AzM0gVWRtzNYgVWRuy9Zsy9cgVWRGcHxty9bb5ORbxdEgVWRty9bn6OZTws9mydRfxtLX3Nva5eRix9NFcXxOd4JPeINQeIMiVmVUws9Vws9Vw9BXw9BYxNBaxNBbxNBcxdJexdElWWgmWmhjyNRlx9IqXGtoipNpytVqytVryNNrytZsjZUuX210k5t1y9R2zNR3y9V4lp57zth9zdaAnKOGoaeK0NiNpquV09mesrag1tuitbmj1tuj19uktrqr2d2svcCu2d2xwMO63N+7x8nA3uDC3uDFz9DK4eHL4eLN4eIyYnDX5OM5Z3Tb397e4uDf4uHf5uXi5ePi5+Xj5+Xk5+Xm5+Xm6OY6aHXQ19fT4+NfhI1Ww89gx9Nhx9Nsy9ZWw9Dpj2abAAAAWnRSTlMAAQICAwQEBgcIDQ0ODhQZGiAiIyYpKywvNTs+QklPUlNUWWJjaGt0dnd+hIWFh4mNjZCSm6CpsbW2t7nDzNDT1dje5efr7PHy9PT29/j4+Pn5+vr8/f39/f6DPtKwAAABTklEQVR4Xr3QVWPbMBSAUTVFZmZmhhSXMjNvkhwqMzMzMzPDeD+xASvObKePPa+ffHVl8PlsnE0+qPpBuQjVJjno6pZpSKXYl7/bZyFaQxhf98hHDKEppwdWIW1frFnrxSOWHFfWesSEWC6R/P4zOFrix3TzDFLlXRTR8c0fEEJ1/itpo7SVO9Jdr1DVxZ0USyjZsEY5vZfiiAC0UoTGOrm9PZLuRl8X+Dq1HQtoFbJZbv61i+Poblh/97TC7n0neCcK0ETNUrz1/xPHf+DNAW9Ac6t8O8WH3Vp98f5lCaYKAOFZMLyHL4Y0fe319idMNgMMp+zWVSybUed/+/h7I4wRAG1W6XDy4XmjR9HnzvDRZXUAYDFOhC1S/Hh+fIXxen+eO+AKqbs+wAo30zDTDvDxKoJN88sjUzDFAvBzEUGFsnADoIvAJzoh2BZ8sner+Ke/vwECuQAAAABJRU5ErkJggg==\");*/\r\n  background-position: center;\r\n  background-repeat: no-repeat;\r\n  float: right;\r\n  height: 42px;\r\n  width: 42px;\r\n  display: none;\r\n}\r\n\r\n.ol-layerswitcher-image li.ol-layer-hidden {\r\n  opacity: 1;\r\n  border-color: rgba(85, 85, 85, 0.5);\r\n}\r\n\r\n.ol-layerswitcher-image li.select,\r\n.ol-layerswitcher-image li.ol-visible {\r\n  border: 3px solid rgb(183, 200, 0);\r\n}\r\n\r\n\r\n\r\n/* Measure Control */\r\n.ol-measure {\r\n  position: absolute;\r\n  top: 10em;\r\n  left: 0.5em;\r\n}\r\n\r\n/* Download ShapeFile Control */\r\n/* .ol-download-shape {\r\n  position: absolute;\r\n  top: 14em;\r\n  left: 0.5em;\r\n} */\r\n\r\n/* Sidebar Control Button */\r\n\r\n.ol-sidebar-control {\r\n  position: relative;\r\n  width: 40px;\r\n  height: 40px;\r\n  border-width: 0px;\r\n  padding: 0px;\r\n}\r\n\r\n.ol-sidebar-control>button {\r\n  margin: 0px;\r\n  height: 100%;\r\n  width: 100%;\r\n}\r\n\r\n.ol-sidebar-control>button:hover {\r\n  /* background-color: rgba(255,211,58, 0.9); */\r\n}\r\n\r\n.ol-bar-sidebar {\r\n  position: relative !important;\r\n}\r\n\r\n.ol-thumb-control>button {\r\n  width: 60px;\r\n  height: 60px;\r\n}\r\n\r\n.ol-thumb-control.ol-active>button {\r\n  /* background-color: rgb(136,149,0) ; */\r\n}\r\n\r\n\r\n.sidebar-map .sidebar-left~.ol-sidebar-sticky {\r\n  margin-left: 46px;\r\n  transition: margin-left 500ms;\r\n}\r\n\r\n@media (min-width: 600x) and (max-width: 900px) {\r\n  .sidebar-map .sidebar-left~.ol-sidebar-sticky {\r\n    margin-left: 317px;\r\n  }\r\n}\r\n\r\n@media (min-width: 900px) and (max-width: 1200px) {\r\n  .sidebar-map .sidebar-left~.ol-sidebar-sticky {\r\n    margin-left: 402px;\r\n  }\r\n}\r\n\r\n@media (min-width: 1200px) {\r\n  .sidebar-map .sidebar-left~.ol-sidebar-sticky {\r\n    margin-left: 472px;\r\n  }\r\n}\r\n\r\n@media (min-width: 600px) {\r\n  .sidebar-map .sidebar-left.collapsed~.ol-sidebar-sticky {\r\n    margin-left: 52px;\r\n    transition: margin-left 500ms;\r\n  }\r\n}\r\n\r\n\r\n/* PUBLIC PAGE */\r\n.ol-zoom-public {\r\n  background-color: rgba(0, 0, 0, 0);\r\n  left: auto;\r\n\r\n}\r\n\r\n@media (min-width: 900px) {\r\n  .ol-zoom-public {\r\n    right: 15px;\r\n    bottom: 125px;\r\n    top: auto;\r\n  }\r\n\r\n  .ol-control.ol-rotate-public {\r\n    right: 17px;\r\n    bottom: 237px;\r\n    top: auto;\r\n  }\r\n\r\n  .ol-control .ol-zoom-in-public {\r\n    margin-bottom: 15px;\r\n  }\r\n}\r\n\r\n@media (max-width: 899px) {\r\n  .ol-zoom-public {\r\n    right: 5px;\r\n    bottom: auto;\r\n    top: 10px;\r\n  }\r\n\r\n  .ol-control.ol-rotate-public {\r\n    right: 7px;\r\n    bottom: auto;\r\n    top: 190px;\r\n  }\r\n}\r\n\r\n.ol-control.ol-rotate-public {\r\n  border-radius: 50%;\r\n  width: 40px;\r\n  height: 40px;\r\n  background-color: rgba(0, 0, 0, 0);\r\n}\r\n\r\n\r\n.ol-rotate-reset.ol-rotate-public {\r\n  border-radius: 50%;\r\n  width: 40px;\r\n  height: 40px;\r\n}\r\n\r\n\r\n.ol-control .ol-zoom-in-public {\r\n  border-radius: 50%;\r\n  width: 40px;\r\n  height: 40px;\r\n  transition: 0.3s;\r\n}\r\n\r\n.ol-control .ol-zoom-out-public {\r\n  border-radius: 50%;\r\n  width: 40px;\r\n  height: 40px;\r\n  margin-top: 5px;\r\n  transition: 0.3s;\r\n}\r\n\r\n.ol-control .ol-zoom-in-public,\r\n.ol-control .ol-zoom-out-public,\r\n.ol-control .ol-zoom-in-public:hover,\r\n.ol-control .ol-zoom-out-public:hover {\r\n  color: #DDFFD7;\r\n}\r\n\r\nbutton.ol-control-public {\r\n  background-color: #005a96;\r\n  border-radius: 50%;\r\n  height: 40px;\r\n  width: 40px;\r\n}\r\n\r\nbutton.custom-control-public {\r\n  border-radius: 50%;\r\n  height: 40px;\r\n  width: 40px;\r\n}\r\n\r\n#overlay-quickactions-overlay {\r\n  position: relative;\r\n  left: 10px;\r\n  margin-top: -17px;\r\n}\r\n\r\n#public_desktop_navlink a.active {\r\n  color: #ff6363;\r\n}\r\n\r\n.ol-overlaycontainer-stopevent {\r\n  z-index: 1 !important;\r\n}\r\n\r\n.pnlm-controls-container {\r\n  right: 24px;\r\n  left: auto;\r\n  bottom: 24px;\r\n  top: auto;\r\n}\r\n\r\n.pnlm-fullscreen-toggle-button {\r\n  border-radius: 50%;\r\n  background-color: #BDBDBD;\r\n  background-size: 20px;\r\n  transform: scale(1.4);\r\n  background-position: 3px -36px;\r\n  border-width: 0;\r\n}\r\n\r\n.pnlm-fullscreen-toggle-button:hover {\r\n  background-color: #b7b7b7;\r\n}\r\n\r\n.pnlm-panorama-info {\r\n  position: absolute;\r\n  top: 4px;\r\n  left: 4px;\r\n  bottom: unset;\r\n  background-color: unset;\r\n  font-family: Roboto, Helvetica, Arial, sans-serif;\r\n  font-size: 0.85rem;\r\n  text-shadow: 1px 1px 5px #000;\r\n}\r\n\r\n.pnlm-title-box {\r\n  margin-bottom: 0px\r\n}\r\n\r\n#apexchartsprofile-chart .apexcharts-xaxis-texts-g {\r\n  transform: scale(0.92, 0.95) translate(15px, 3px);\r\n}\r\n\r\n\r\n.public-content-wrapper {\r\n  scrollbar-width: thin;\r\n}\r\n\r\n.public-content-wrapper *::-webkit-scrollbar {\r\n  width: 7px;\r\n  height: 7px;\r\n}\r\n\r\n.public-content-wrapper *::-webkit-scrollbar-track {\r\n  background: #FAFAFA;\r\n}\r\n\r\n/* change color if changing theme */\r\n.public-content-wrapper *::-webkit-scrollbar-thumb {\r\n  background-color: #005A96;\r\n  border: 0px solid #FAFAFA;\r\n}\r\n\r\n.apexcharts-tooltip-goals-group .apexcharts-tooltip-z-group {\r\n  display: none\r\n}\r\n\r\n.apexcharts-profile-box {\r\n  width: 50px;\r\n  display: flex;\r\n  flex-direction: column;\r\n}\r\n\r\n.apexcharts-profile-top {\r\n  margin-top: 1px;\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  font-family: 'Arial';\r\n  font-size: 12px;\r\n}\r\n\r\n.apexcharts-profile-bottom {\r\n  margin-bottom: 1px;\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  font-family: 'Arial';\r\n  font-size: 12px;\r\n}\r\n\r\n.custom-chart-tooltip {\r\n  margin: 3px;\r\n}\r\n\r\n.ol-compass svg {\r\n  filter: invert(100%);\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
